export default {
  assignmentColumnHeader: [
    {
      id: 'title',
      textLabel: '名稱',
      type: 'text',
      width: '25%',
    },
    {
      id: 'date',
      textLabel: '期限',
      type: 'text',
      width: '105px',
      noWrap: true,
    },
    {
      id: 'duration',
      textLabel: '時段',
      type: 'text',
      width: '105px',
      noWrap: true,
    },
    {
      id: 'checkers',
      textLabel: '答題者',
      type: 'avatars',
      width: '150px',
    },
    {
      id: 'reviewers',
      textLabel: '覆核者',
      type: 'avatars',
      width: '150px',
    },

    {
      id: 'rowItembutton',
      type: 'rowItembutton',
      width: '10%',
      align: 'right',
    },
  ],
  futureAssignmentColumnHeader: [
    {
      id: 'title',
      textLabel: '名稱',
      type: 'text',
      width: '25%',
    },
    {
      id: 'date',
      textLabel: '期限',
      type: 'text',
      width: '105px',
      noWrap: true,
    },
    {
      id: 'duration',
      textLabel: '時段',
      type: 'text',
      width: '105px',
      noWrap: true,
    },
    {
      id: 'checkers',
      textLabel: '答題者',
      type: 'avatars',
      width: '150px',
    },
    {
      id: 'reviewers',
      textLabel: '覆核者',
      type: 'avatars',
      width: '150px',
    },
  ],
  reviewerColumnHeader: [
    {
      id: 'title',
      textLabel: '名稱',
      type: 'text',
      width: '25%',
    },
    {
      id: 'date',
      textLabel: '填表日期',
      type: 'text',
      width: '105px',
      noWrap: true,
    },
    {
      id: 'duration',
      textLabel: '時段',
      type: 'text',
      width: '105px',
      noWrap: true,
    },
    {
      id: 'checkers',
      textLabel: '答題者',
      type: 'avatars',
      width: '150px',
    },
    {
      id: 'reviewers',
      textLabel: '覆核者',
      type: 'avatars',
      width: '150px',
    },
    {
      id: 'rowItembutton',
      type: 'rowItembutton',
      width: '10%',
      align: 'right',
    },
  ],
  recordColumnHeader: [
    {
      id: 'title',
      textLabel: '名稱',
      type: 'text',
      width: '15%',
    },
    {
      id: 'date',
      textLabel: '填表日期',
      type: 'text',
      width: '105px',
      noWrap: true,
    },
    {
      id: 'duration',
      textLabel: '時段',
      type: 'text',
      width: '105px',
      noWrap: true,
    },
    {
      id: 'checkers',
      textLabel: '答題者',
      type: 'avatars',
      width: '150px',
    },
    {
      id: 'reviewers',
      textLabel: '覆核者',
      type: 'avatars',
      width: '150px',
    },
    {
      id: 'riskLevel',
      textLabel: '結果',
      type: 'icon',
      width: '10%',
      padding: '15px 10px 15px 13px'
    },
    {
      id: 'passRate',
      textLabel: '合規率',
      type: 'text',
      width: '10%',
    },
    {
      id: 'rowItembutton',
      type: 'rowItembutton',
      align: 'right',
    },
  ],
  draftColumnHeader: [
    {
      id: 'title',
      textLabel: '名稱',
      type: 'text',
      width: '25%',
    },
    {
      id: 'date',
      textLabel: '期限',
      type: 'text',
      width: '105px',
      noWrap: true,
    },
    {
      id: 'duration',
      textLabel: '時段',
      type: 'text',
      width: '105px',
      noWrap: true,
    },
    {
      id: 'checkers',
      textLabel: '答題者',
      type: 'avatars',
      width: '150px',
    },
    {
      id: 'reviewers',
      textLabel: '覆核者',
      type: 'avatars',
      width: '150px',
    },

    {
      id: 'rowItemButtonList',
      type: 'rowItemButtonList',
      width: '10%',
      align: 'right',
    },
  ],
  undoTemporaryColumnHeader: [
    {
      id: 'title',
      textLabel: '名稱',
      type: 'text',
      width: '25%',
    },
    {
      id: 'checkers',
      textLabel: '答題者',
      type: 'avatars',
      width: '150px',
    },
    {
      id: 'createdAt',
      textLabel: '建立時間',
      type: 'text',
      width: '150px',
    },
    {
      id: 'reviewers',
      textLabel: '覆核者',
      type: 'avatars',
      width: '150px',
    },
    {
      id: 'rowItemButtonList',
      type: 'rowItemButtonList',
      width: '10%',
      align: 'right',
    },
  ],
  temporaryAssignmentRowItemButtonList: {
    noWrap: true,
    list: [
      {
        text: '繼續點檢',
        value: 'continue',
      },
      {
        text: '刪除',
        value: 'delete',
        color: 'red',
      },
    ],
  },
};
